/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_DisqualifiedInputs */



/**
* | output |
* | --- |
* | "Disqualified" |
*
* @param {Tournament_DisqualifiedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_disqualified = /** @type {((inputs?: Tournament_DisqualifiedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_DisqualifiedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Disqualifié")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descalificado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Desqualificado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Squalificato")
	return /** @type {LocalizedString} */ ("Disqualified")
});